import styled from 'styled-components';

export const PopularBusRoutes = styled.section(
  props => `
    margin-bottom: 7rem;
    h3 {
        font-size: 2.2rem;
        color: rgb(20, 24, 35);
        font-family: ${props.theme.font.fontFamily};
        font-weight: bold;
        padding-bottom: 1.5rem;
    }
`,
);

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RouteBlock = styled.section`
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.1rem 0.4rem 0px;
  border-radius: 0.6rem;
  padding: 0 2rem;
  display: flex;
  ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    li {
      width: 33%;
      display: flex;
      flex-direction: row;
      padding: 2rem 0;
    }
  }
  a:first-child {
    padding-left: 2px;
  }
`;
export const BusDetails = styled.div``;
export const CardHeader = styled.p(
  props => `
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 1.2;
    padding-bottom: 0.5rem;
    `,
);
export const SmallTxt = styled.p`
  font-size: 1.4rem;
`;
